import script from "./module.vue?vue&type=script&setup=true&lang=js"
export * from "./module.vue?vue&type=script&setup=true&lang=js"

import "./module.vue?vue&type=style&index=0&id=8f0e9df2&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f0e9df2"]])

export default __exports__